<template>
      <div class="basket__list__block">
          <div class="basket__list">
                <div v-if="cart_data_item.remain <= 0" class="remain_null">
                    <p>
                        Предзаказ товара
                    </p>
                </div>
              <div class="basket__list__img">
                <img
                    v-if="cart_data_item.img"
                    :src="'https://ecodom04.com/backend/'+ cart_data_item.img"
                    alt="images"
                >
                <img
                    v-if="!cart_data_item.img"
                    src="../assets/not_found.png"
                    alt="images"
                >
              </div>
              <div class="basket__list__text">
                  <h1>{{cart_data_item.title}}</h1>
                  <div class="basket__list__text_p" id="basket__list__text_p_scroll">
                    <p>
                        {{cart_data_item.description}}
                    </p>
                  </div>
              </div>
              <div class="basket__list__btn">
                  <div class="basket__list__btn__price">
                      <p>
                          <span>{{cart_data_item.price | numeral('0,0')}}</span> ₸
                      </p>
                  </div>
                  <div class="basket__list__btn__count">
                      <button @click="decrementPrice">
                          <span class="mdi mdi-minus"></span>
                      </button>
                      <input type="text" class="basketInput" @input="quantityChange" :value="cart_data_item.quantity">
                      <button @click="incrementPrice">
                          <span class="mdi mdi-plus"></span>
                      </button>
                  </div>
                  <div class="basket__list__btn__remove">
                      <button @click="deleteFromCart">
                          <span class="mdi mdi-trash-can-outline"></span>
                          Удалить
                      </button>
                  </div>
              </div>
          </div>
      </div>
</template>

<script>
export default {
  name: 'cartitem',
  props: {
      cart_data_item: {
          type: Object,
          default (){
              return {}
          }
      }
  },
  methods: {
    deleteFromCart() {
        this.$emit('deleteFromCart')
    },
    decrementPrice() {
        this.$emit('decrementPrice')
    },
    incrementPrice() {
        this.$emit('incrementPrice')
    },
    quantityChange() {
        this.$emit('quantityChange')
    }
  },
}
</script>
<style scoped lang="less">
@baseMedia: 900px;

    .basket__list__block {
        width: 90%;
        margin: 0 auto;
        margin-bottom: 15px;
        margin-top: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
        .basket__list {
            width: 100%;
            padding: 10px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #ccc;
            position: relative;
            @media (max-width: @baseMedia) {
                justify-content: center;
                flex-wrap: wrap;
            }
            .remain_null {
                padding: 5px 10px;
                color: #000;
                font-weight: bold;
                background: #eefd00;
                font-weight: bold;
                border-radius: 5px;
                position: absolute;
                top: 0;
                box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.75);
                left: 0;
                @media (max-width: @baseMedia) {
                    padding: 2px 5px;
                    font-size: 12px;
                }
            }
            .basket__list__img {
                width: 23%;
                height: 150px;
                overflow: hidden;
                cursor: pointer;
                text-align: center;
                @media (max-width: @baseMedia) {
                    height: 100px;
                    width: 100%;
                }
                img {
                    height: 100%;

                    &:hover {
                        transition: 2s;
                        height: 110%;
                    }
                }
            }
            .basket__list__text {
                width: 65%;
                padding-right: 10px;
                @media (max-width: @baseMedia) {
                    width: 100%;
                    padding-right: 0px;
                }
                h1 {
                    font-size: 20px;
                    @media (max-width: @baseMedia) {
                            font-size: 16px;
                    }
                }
                #basket__list__text_p_scroll::-webkit-scrollbar-track
                {
                    background-color: transparent;
                }

                #basket__list__text_p_scroll::-webkit-scrollbar
                {
                    width: 5px;
                }

                #basket__list__text_p_scroll::-webkit-scrollbar-thumb
                {
                    background-color: #ccc;
                }
                .basket__list__text_p {
                    width: 100%;
                    height: 125px;
                    overflow-y: scroll;
                    @media (max-width: @baseMedia) {
                        height: 52px;
                        margin-bottom: 10px;
                    }
                    p {
                        font-size: 15px;
                        margin-top: 15px;
                        @media (max-width: @baseMedia) {
                            margin-top: 5px;
                        }
                    }
                }
            }
            .basket__list__btn {
                width: 10%;
                @media (max-width: @baseMedia) {
                    width: 100%;
                }
                .basket__list__btn__price{
                     background: #fafaca;
                     width: 100%;
                     box-shadow: 0px 1px 6px 0px rgba(17,102,9,1);
                     padding-top: 5px;
                     padding-bottom: 5px;
                     p {
                         font-size: 20px;
                         color: #690;
                         text-align: center;
                         @media (max-width: @baseMedia) {
                            font-size: 16px;
                         }
                         span {
                             font-weight: bold;
                         }
                     }
                }
                .basket__list__btn__count {
                    width: 99%;
                    display: flex;
                    background: #fafaca;
                    justify-content: space-between;
                    box-shadow: 0px 1px 6px 0px #116609;
                    margin-top: 15px;
                    @media (max-width: @baseMedia) {
                        margin-top: 10px;
                    }
                    input {
                        width: 60px;
                        height: 35px;
                        text-align: center;
                        outline: none;
                        @media (max-width: @baseMedia) {
                            width: 77px;
                            height: auto;
                        }
                    }
                    button {
                        background: #5e8d00;
                        height: 35px;
                        width: 40px;
                        outline-color: #5e8d00;
                        @media (max-width: @baseMedia) {
                            height: 29px;
                        }
                        span {
                            color: #fff;
                        }
                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
                .basket__list__btn__remove {
                    width: 100%;
                    margin-top: 15px;
                    @media (max-width: @baseMedia) {
                        margin-top: 10px;
                    }
                    button {
                        background: #b70e27;
                        height: 35px;
                        width: 100%;
                        font-weight: bold;
                        color: #fff;
                        &:hover {
                            opacity: 0.7;
                        }
                        span {
                            color: #fff;
                        }
                        @media (max-width: @baseMedia) {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
</style>